/*
 * normalizeString.ts
 * Normalizes a given string. It removes dots and replaces spaces with dashes.
 */

export const normalizeString = (name: string) => {
    return name
        .toLowerCase()
        .replace(/\./g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}